const Single = {
  init: () => {
    // check single post page
    const isSinglePost = document.querySelector("body.single");
    if (!isSinglePost) return;
    console.log("single");
  },
};

export default Single;
